import React from 'react'

import FillableStar from './FillableStar'

/*
Displays a series of stars filled in based on the rating

Usage:
    <StarRating rating={4.5} outOf={5} />

*/

const StarRating = ({ rating, outOf }) => {
  return (
    <>
      {Array.from({ length: outOf }).map((_, i) => {
        let starVal = 0
        if (rating >= i + 1) {
          starVal = 100
        } else {
          starVal = (rating - i) * 100
          if (starVal < 0) {
            starVal = 0
          }
        }
        return <FillableStar key={i} percent={starVal} />
      })}
    </>
  )
}

export default StarRating
